import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { IRequestLiberacaoTomador } from "src/app/domain/interfaces/request-liberacao-tomador.interface";
import { RatingViewModel } from "src/app/domain/viewmodels/rating.viewmodel";
import { environment } from "src/environments/environment";
import { RetornaDadosRequest } from "../../../helpers/retorna-dados-request";

@Injectable({
	providedIn: "root"
})
export class LiberacaoPropostaTomadorService {
	constructor(
		private http: HttpClient,
		private retornoStatus: RetornaDadosRequest
	) {}

	getRatings(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/ParameterTaker/GetRatings`);
	}

	getCustumerSegmentations(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/ParameterTaker/GetCustumerSegmentations`);
	}

	atualizarLiberacaoPropostatomador(request: IRequestLiberacaoTomador): Observable<any> {
		return this.http.put(`${environment.urlApi}/ParameterTaker/Update`, request);
	}

	insertLiberacaoPropostaTomador(request: any): Observable<any> {
		return this.http.post(`${environment.urlApi}/ParameterTaker/Insert`, request);
	}

	filter(request: any): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/ParameterTaker/Filter`, request);
	}

	disable(request: any): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/ParameterTaker/Disable`, request);
	}

	getParametroTomadorByTomadorAndProposta(
		idTomador: number,
		idTipoDeProposta: number,
		idCorretora: number
	): Observable<any> {
		return this.http.get<any>(
			`${environment.urlApi}/ParameterTaker/GetParameterTomador?idTomador=${idTomador}&idTipoDeProposta=${idTipoDeProposta}&idCorretora=${idCorretora}`
		);
	}

	getValidatingParametroTomador(idTomador: number, idParametroTomador: number) {
		return this.http.get<any>(
			`${environment.urlApi}/ParameterTaker/GetValidaRatingAndSegmentacaoTomador?idTomador=${idTomador}&idParametroTomador=${idParametroTomador}`
		);
	}

	getById(id: number) {
		return this.http.get<any>(`${environment.urlApi}/ParameterTaker/GetById?id=${id}`);
	}
}
